import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import arraySupport from "dayjs/plugin/arraySupport";
// import { useAccountStore } from "../libs/stores/account";
// import { useUserStore } from "../libs/stores/user";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(arraySupport);

const DATE_FORMAT = {
  DATETIME: "DateTime",
  TIMEONLY: "TimeOnly",
  DATEONLY: "DateOnly"
};

let userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
let locale = "en-US";
let dateFormat, timeFormat, dateTimeFormatPattern;

// const getLocaleDetails = userDetails => {
//   if (userDetails && userDetails.TimeZone && userDetails.TimeZone._id) {
//     userTimezone = userDetails.TimeZone._id;
//   }
//   try {
//     if (userDetails.Locale && userDetails.Locale._id) {
//       locale = userDetails.Locale && userDetails.Locale._id;
//       dateFormat = userDetails.Locale && userDetails.Locale.Date.DateFormat;
//       dateFormat = dateFormat.replace(/d/g, "D").replace(/y/g, "Y");
//       timeFormat = userDetails.Locale && userDetails.Locale.Date.TimeFormat;
//       dateTimeFormatPattern =
//         userDetails.Locale && userDetails.Locale.Date.DateTimeFormat;
//     }
//   } catch (e) {
//     console.log(e);
//   }
// };

// let userDetail = useUserStore.getState().currentUser;
// let accountDetail = useAccountStore.getState().getAccountDetails(); // Using account details for publicform
// userDetail = Object.keys(userDetail).length > 0 ? userDetail : accountDetail;
// getLocaleDetails(userDetail);

const formatDate = (date, withTime) => {
  if (!date) {
    return;
  }
  let month =
    date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  let day = date.getDate() < 9 ? `0${date.getDate()}` : date.getDate();
  if (withTime) {
    let timezone =
      userTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    month = date.getMonth();
    day = date.getDate();
    let year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let datetimeString = `${dayjs([year, month, day, hours, minutes])
      .tz(timezone)
      .format("YYYY-MM-DDTHH:mm:00Z")} ${timezone}`;
    return datetimeString;
  } else {
    return `${date.getFullYear()}-${month}-${day}`;
  }
};

const parseDate = (dateString, withTime, convertToTimezone) => {
  if (!dateString) return;
  try {
    if (withTime) {
      let timezone =
        dateString.split(" ")[1] ||
        userTimezone ||
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (convertToTimezone) {
        timezone = userTimezone;
      }
      let dateTimeString = dateString.split(" ")[0];
      return dayjs(dateTimeString).tz(timezone).format("YYYY-MM-DD HH:mm");
    }
  } catch (e) {
    console.error("Could not parse Date", e);
  }
  return dateString;
};

const formatToLocale = (
  dateString,
  withTime,
  convert,
  dateTimeFormat = DATE_FORMAT.DATEONLY,
  isComputedValue
) => {
  if (!dateString) return;
  if (!withTime && !dateTimeFormat) {
    dateTimeFormat = DATE_FORMAT.DATEONLY;
  }
  let parsedDateString;
  if (isComputedValue) {
    parsedDateString = dateString;
  } else {
    parsedDateString = parseDate(dateString, withTime, convert);
  }
  let value = parsedDateString && parsedDateString.split(/[^0-9]/);
  if (locale) {
    if (dateTimeFormat === DATE_FORMAT.DATEONLY) {
      dateTimeFormat = dateFormat || "YYYY-MM-DD";
    }
    if (dateTimeFormat === DATE_FORMAT.TIMEONLY) {
      dateTimeFormat = timeFormat || "HH:mm";
    }
    if (withTime || dateTimeFormat === DATE_FORMAT.DATETIME) {
      dateTimeFormat =
        dateTimeFormatPattern &&
        dateTimeFormatPattern
          .replace("{1}", dateFormat)
          .replace("{0}", timeFormat);
      if (!dateTimeFormat) {
        dateTimeFormat = "YYYY-MM-DD HH:mm";
      }
    }
    if (withTime) {
      value =
        value &&
        dayjs(
          new Date(value[0], value[1] - 1, value[2], value[3], value[4])
        ).format(dateTimeFormat);
    } else {
      value =
        value &&
        dayjs(new Date(value[0], value[1] - 1, value[2])).format(
          dateTimeFormat
        );
    }
  }
  return value;
};

// const convertUtcToLocaleWithTZ = (dateString, withTime, convert) => {
//   let localeTime = formatToLocale(dateString, withTime, convert);
//   let timeZone = moment.tz(userTimezone).format('z');
//   return `${localeTime} ${timeZone}`;
// };

const parseFromLocale = (dateString, withTime) => {
  if (!dateString) {
    return;
  }
  let validDateFormats = [];
  let dateTimeFormat = dateFormat;
  let defaultDateTimeFormat = ["YYYY-MM-DD"];
  if (withTime) {
    dateTimeFormat =
      dateTimeFormatPattern &&
      dateTimeFormatPattern
        .replace("{1}", dateFormat)
        .replace("{0}", timeFormat);
    defaultDateTimeFormat = [
      "YYYY-MM-DD HH:mm",
      "YYYY-MM-DD HH:mm A",
      "YYYY-MM-DDTHH:mm:ssZ"
    ];
  }
  if (dateTimeFormat && dateString.indexOf("-") >= 0) {
    validDateFormats = [
      dateTimeFormat,
      dateTimeFormat.replace("YY", "YYYY"),
      dateTimeFormat + " A",
      ...defaultDateTimeFormat
    ];
  } else if (dateTimeFormat) {
    validDateFormats = [dateTimeFormat.replace("YY", "YYYY")];
  } else {
    validDateFormats = [...defaultDateTimeFormat];
  }
  if (dateTimeFormatPattern === "{0}, {1}" && withTime) {
    let dateTime = validDateFormats[0].split(",");
    let format = dateTime[1].trim() + " " + dateTime[0];
    validDateFormats = [validDateFormats[0], format, format + " A"];
  }
  let momentDate = dayjs(dateString, validDateFormats);
  if (!momentDate.isValid()) {
    return null;
  }
  return momentDate.toDate();
};

const getMonthName = (dateString, fullName = false) => {
  let date = new Date(dateString);
  return fullName ? dayjs(date).format("MMMM") : dayjs(date).format("MMM");
};

const convertLocalToUTC = (date, withTime) => {
  let dateTimeString = formatDate(date, withTime);
  // dateTimeString will be in format 'YYYY-MM-DDTHH:mm:00Z Asia/Calcutta' so ignoring timezone
  let momentUTC = dayjs(dateTimeString.split(" ")[0]).tz("UTC");
  return momentUTC;
};

const dateFromString = (dateStrig) => {
  let dateTime = dateStrig.split(" ");
  let date;
  if (dateTime.length > 1) {
    date = new Date(dateTime[0]);
    let time = dateTime[1] && dateTime[1].split(":");
    date.setHours(time[0]);
    date.setMinutes(time[1]);
  } else {
    date = new Date(dateStrig);
  }
  return date;
};

const toDateObject = (value) => {
  let datetimeValue = value.split(" ");
  let dateObject = datetimeValue[0].split("-");
  let timeObject = datetimeValue[1].split(":");
  return new Date(
    dateObject[0],
    dateObject[1] - 1,
    dateObject[2],
    timeObject[0],
    timeObject[1]
  );
};

export {
  formatDate,
  parseDate,
  formatToLocale,
  parseFromLocale,
  convertLocalToUTC,
  getMonthName,
  dateFromString,
  toDateObject
};
